import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiMintMetrics } from "@/generated/models/ApiMintMetrics";
import type { ApiMintMetricsPage } from "@/generated/models/ApiMintMetricsPage";
import { commonApiFetch } from "@/services/api/common-api";
export interface MintMetricsData {
  readonly items: ApiMintMetrics[];
  readonly totalCount: number;
}
async function fetchMintMetrics(pageSize: number): Promise<MintMetricsData> {
  const response = await commonApiFetch<ApiMintMetricsPage>({
    endpoint: "community-metrics/mints",
    params: {
      page_size: String(pageSize),
      sort: "mint_time",
      sort_direction: "DESC"
    }
  });
  return {
    items: response.data,
    totalCount: response.count
  };
}
export function useMintMetrics(t0) {
  const $ = _c(2);
  const pageSize = t0 === undefined ? 10 : t0;
  let t1;
  if ($[0] !== pageSize) {
    t1 = {
      queryKey: [QueryKey.MINT_METRICS, {
        pageSize
      }],
      queryFn: () => fetchMintMetrics(pageSize),
      staleTime: 60000,
      gcTime: 300000,
      retry: 3,
      retryDelay: _temp,
      refetchOnWindowFocus: false,
      refetchOnMount: true
    };
    $[0] = pageSize;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useQuery(t1);
}
function _temp(attemptIndex) {
  return Math.min(1000 * 2 ** attemptIndex, 30000);
}